import { Layers } from "lucide-react";
import { C } from "../../lib/api";

// Format + game filters over the admin table list, the same idea as the lobby filters players see.
export const FORMATS = [
  { key: "all", label: "All" },
  { key: "CASH", label: "Cash" },
  { key: "SNG", label: "Sit N Go" },
  { key: "MTT", label: "MTT" },
];

const Pill = ({ active, label, count, testid, onClick }) => (
  <button data-testid={testid} data-active={active ? "true" : "false"} onClick={onClick}
    className={`rounded-full px-3 py-1.5 text-[11px] tracking-wide transition-colors flex items-center gap-1.5 ${active ? "bg-amber-500 text-slate-900 font-semibold" : "bg-white/5 text-slate-300 hover:bg-white/10 border border-white/10"}`}>
    {label}{count != null && <span className={`font-mono text-[10px] ${active ? "text-slate-800" : "text-slate-500"}`}>{count}</span>}
  </button>
);

export const AdminTableFilters = ({ rows, format, game, onFormat, onGame }) => {
  const byFormat = (f) => (f === "all" ? rows : rows.filter((r) => r.format === f));
  const games = [...new Set(byFormat(format).map((r) => r.game))].sort((a, b) => (C.GAME_RULES[a]?.label || a).localeCompare(C.GAME_RULES[b]?.label || b));
  return (
    <div className="flex flex-col gap-2" data-testid="admin-table-filters">
      <div className="flex items-center gap-2 flex-wrap">
        <Layers className="w-3.5 h-3.5 text-slate-500" />
        {FORMATS.map((f) => (
          <Pill key={f.key} testid={`admin-filter-format-${f.key}`} label={f.label} count={byFormat(f.key).length}
            active={format === f.key} onClick={() => { onFormat(f.key); onGame("all"); }} />
        ))}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <Pill testid="admin-filter-game-all" label="Every game" count={byFormat(format).length} active={game === "all"} onClick={() => onGame("all")} />
        {games.map((g) => (
          <Pill key={g} testid={`admin-filter-game-${g}`} label={C.GAME_RULES[g]?.label?.replace(/^No-Limit |^Pot-Limit |^Fixed-Limit /, "") || g}
            count={byFormat(format).filter((r) => r.game === g).length} active={game === g} onClick={() => onGame(g)} />
        ))}
      </div>
    </div>
  );
};
